/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFieldComponent } from '../../Base/base-field.component';

@Component({
  selector: 'ds-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
})
export class SelectComponent extends BaseFieldComponent {
  @Input() options: string[] = [];

  @Input() isHierarchy = false;
  @Input() selectWithOutEmptyValue = false;
  @Output() selectionChange = new EventEmitter<string>();

  selectionChanged(event: any) {
    this.onChange(event.target.value);
    this.selectionChange.emit(event.target.value);
  }

  // Implement the ControlValueAccessor methods
  protected override onChange: (value: string) => void = () => {};

  override writeValue(value: string): void {
    this.value = value;
  }
  override registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }
}
